import { useDispatch, useSelector } from "@/types/store";
import React, { useState } from "react";
import * as chatGPTReducer from "@/containers/ChatGPT/reducer";
import { getModelOptions } from "@/containers/ChatGPT/reducer";
import { getSelectedFolder } from "@/containers/Folders/reducer";
import { createTone } from "@/containers/ChatTone/reducer";
import styles from "../style.module.css";
import { LineInput } from "@/components/Inputs/LineInput";
import TextInput from "@/components/Inputs/TextInput";
import Select from "react-select";
import { Button } from "@/aible";
export const CreateToneView = ({ updateIsCreatingTone }) => {
    const dispatch = useDispatch();
    const [name, updateName] = useState(undefined);
    const [instructions, updateInstructions] = useState(undefined);
    const [variants, updateVariants] = useState([]);
    const [modelExclusions, updateModelExclusions] = useState(undefined);
    const [isLoading, updateIsLoading] = useState(false);
    const modelOptions = useSelector((state) => getModelOptions(state));
    const folderId = useSelector(getSelectedFolder);
    const updateChatTone = (val) => dispatch(chatGPTReducer.updateChatTone(val));
    const handleCreateNewTone = () => {
        const retValues = {};
        // Using instructions to set metadata for all modelOptions
        modelOptions.forEach((o) => {
            retValues[o.value] = instructions ?? "";
        });
        // Update each variant model with their instruction
        if (variants?.length > 0) {
            variants.forEach((variant) => {
                if (variant?.models?.length > 0) {
                    variant?.models?.forEach((v) => {
                        retValues[v.value] = variant?.instructions ?? "";
                    });
                }
            });
        }
        // Set each exception model with blank instructions
        if (modelExclusions && modelExclusions?.length > 0) {
            modelExclusions.forEach((exclusion) => {
                retValues[exclusion.value] = "";
            });
        }
        const toneName = name && name?.length > 0 ? name : "New Chat Tone";
        const newTone = {
            folder_id: folderId,
            name: toneName,
            metadata: {
                values: retValues
            }
        };
        // console.log("New tone is: ", newTone);
        updateIsLoading(true);
        dispatch(createTone(newTone)).then((tone) => {
            updateIsLoading(false);
            // console.log("Updating tone", tone);
            updateChatTone(tone?.id);
            updateIsCreatingTone(false);
        });
    };
    const handleUpdateVariantKeyValue = (variant, key, index, val) => {
        const variantUpdate = {
            ...variant,
            [key]: val
        };
        const retVariants = variants?.slice();
        retVariants[index] = variantUpdate;
        updateVariants(retVariants);
    };
    const handleDeleteVariant = (index) => {
        const retVariants = variants?.slice();
        retVariants.splice(index, 1);
        updateVariants(retVariants);
    };
    //Disable saving unless name + (some instructions OR a variant with models and some instructions)
    // const disableSaving = !((name && name.length > 0) &&
    // ((instructions && instructions.length > 0) ||
    // (variants?.length > 0 && variants.some((v) => v.models?.length > 0 && v.instructions?.length > 0))));
    return (React.createElement("div", null,
        React.createElement("div", { className: styles.toneCreateNameWrapper },
            React.createElement(LineInput, { value: name, onChange: (name) => updateName(name), isDisabled: isLoading, placeholder: "Name this tone" })),
        React.createElement("div", { className: styles.toneCreateSettingsWrapper },
            React.createElement("div", { className: styles.toneCreateItemWrapper },
                React.createElement("div", { className: styles.toneCreateLabelText }, "Tone Instructions"),
                React.createElement(TextInput, { className: styles.chatToneTextInput, value: instructions ?? "", onChange: (val) => {
                        updateInstructions(val);
                    }, updateInstant: undefined, isDisabled: isLoading })),
            variants.map((variant, index) => {
                return (React.createElement("div", { className: styles.toneCreateItemWrapper, key: variant?.models?.length > 0
                        ? "variant__" + variant?.models[0]?.label + "__" + index
                        : "variant__" + index },
                    React.createElement("div", { className: styles.toneCreateItemActionsWrapper },
                        React.createElement("div", { className: styles.toneCreateSelectWrapper },
                            React.createElement(Select, { value: variant.models ?? [], placeholder: "Select models for this variant", options: modelOptions.filter((o) => !variants?.some((variant) => variant?.models?.some((v) => v?.value === o?.value))), onChange: (val) => {
                                    handleUpdateVariantKeyValue(variant, "models", index, val);
                                }, isMulti: true, isDisabled: isLoading })),
                        React.createElement("div", null,
                            React.createElement(Button, { type: "secondary", onClick: () => {
                                    handleDeleteVariant(index);
                                } }, "Delete Variant"))),
                    React.createElement("div", null,
                        React.createElement(TextInput, { className: styles.chatToneTextInput, value: variant?.instructions, onChange: (val) => {
                                handleUpdateVariantKeyValue(variant, "instructions", index, val);
                            }, updateInstant: undefined, isDisabled: isLoading }))));
            }),
            React.createElement("div", { className: styles.toneCreateItemWrapper + " " + styles.toneCreateAddItemWrapper },
                React.createElement("div", { className: styles.toneCreateAddItemLabel }, "Need to add instructions for specific model(s)?"),
                React.createElement(Button, { type: "secondary", onClick: () => {
                        const newVariant = {
                            models: [],
                            instructions: ""
                        };
                        const retVariants = [...variants, newVariant];
                        updateVariants(retVariants);
                    }, isSmall: true, disabled: isLoading }, "Add LLM Specific Variant")),
            modelExclusions ? (React.createElement("div", { className: styles.toneCreateItemWrapper },
                React.createElement("div", { className: styles.toneCreateLabelText }, "Exclude these models from this tone"),
                React.createElement("div", { className: styles.toneCreateSelectWrapper },
                    React.createElement(Select, { value: modelExclusions ?? [], placeholder: "Select models for this variant", options: modelOptions?.filter((o) => !modelExclusions?.some((e) => e?.value === o?.value)), onChange: (val) => {
                            updateModelExclusions(val);
                        }, isMulti: true, isDisabled: isLoading })))) : (React.createElement("div", { className: styles.toneCreateItemWrapper + " " + styles.toneCreateAddItemWrapper },
                React.createElement("div", { className: styles.toneCreateAddItemLabel }, "Want to prevent some models from using this tone?"),
                React.createElement(Button, { type: "secondary", onClick: () => {
                        updateModelExclusions([]);
                    }, isSmall: true, disabled: isLoading }, "Select Models to Exclude")))),
        React.createElement("div", { className: styles.toneCreateFooterActions },
            React.createElement(Button, { type: "secondary", onClick: () => {
                    updateIsCreatingTone(false);
                }, disabled: isLoading }, "Cancel"),
            React.createElement(Button, { type: "primary", onClick: () => {
                    handleCreateNewTone();
                }, isLoading: isLoading }, "Save Tone"))));
};
